import { render, staticRenderFns } from "./auth-popup.vue?vue&type=template&id=3efe3aee&"
import script from "./auth-popup.vue?vue&type=script&lang=js&"
export * from "./auth-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports